import { Button } from '@blueprintjs/core';
import PropTypes from 'prop-types';

const CancelButton = ({
  buttonText = 'Cancel',
  onCancel = () => {},
  miniVersion = false,
  fill = true,
}) => {
  return (
    <div style={{ backgroundColor: 'white', ...(fill && { width: '100%' }) }}>
      <Button
        small={miniVersion}
        minimal={miniVersion}
        fill={fill}
        outlined
        intent='danger'
        icon={'cross'}
        onClick={onCancel}>
        {!miniVersion && buttonText}
      </Button>
    </div>
  );
};

CancelButton.propTypes = {
  buttonText: PropTypes.string,
  onCancel: PropTypes.func,
  miniVersion: PropTypes.bool,
  fill: PropTypes.bool,
};

export default CancelButton;
